import React, { useState, useEffect } from 'react';
import { Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from "react-router-dom";
import axios from 'axios';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import { useLocation } from 'react-router-dom';

const View_Sub = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const baseURL = process.env.REACT_APP_API_BASE_URL;
      const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const sno = queryParams.get('sno'); // dynamically get sno

    useEffect(() => {
        if (!sno) return; // prevent API call if no sno
        axios.get(`${baseURL}/subscriber-packing-item-view/${sno}`)
            .then(response => {
                setData(response.data.data);
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching subscriber packing data:", error);
                setLoading(false);
            });
    }, [sno]); // re-run effect if sno changes


    if (loading) return <div>Loading...</div>;
    if (!data) return <div>No data found</div>;

    const onInit = () => { };

    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>View Subscription Packing</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Production Management</li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Manage Packing</li>
                    </ol>
                </div>
                <div className='d-flex flex-column align-items-center justify-content-center gap-1'>
                    {data.packing_status === 0 && (
                        <Badge bg="info" className="text-white rounded font-w500 fs-7">Yet to Pack</Badge>
                    )}
                    {data.packing_status === 1 && (
                        <Badge bg="danger" className="text-white rounded font-w500 fs-7">Packing</Badge>
                    )}
                    {data.packing_status === 2 && (
                        <Badge bg="success" className="text-white rounded font-w500 fs-7">Packed</Badge>
                    )}
                    {data.packing_status === 3 && (
                        <Badge bg="primary" className="text-white rounded font-w500 fs-7">Dispatched</Badge>
                    )}
                    <OverlayTrigger
                        trigger="hover"
                        placement="bottom"
                        overlay={<Tooltip><span className='fs-8 text-white fw-semibold'>Packing Date</span></Tooltip>}
                    >
                       <label className='text-black font-w500 fs-7'>
                            {new Date(data.packing_date).toLocaleDateString('en-GB', {
                                day: '2-digit',
                                month: 'short',
                                year: 'numeric'
                            })}
                            </label>

                    </OverlayTrigger>
                </div>

            </div>

            <div className='row mb-2'> 

                <div className="col-lg-3 col-md-4 col-sm-2 mb-2 px-4 py-4 mx-4" style={{borderRight: '1px solid #bebebeff'}}>
                    <div className='row'>
                        <div className='col-lg-12 col-md-12 col-sm-12 d-flex flex-column mb-3'>
                            <div className='d-flex align-items-center justify-content-start gap-2'>
                                <LightGallery
                                    onInit={onInit}
                                    speed={500}
                                    plugins={[lgThumbnail, lgZoom]}
                                >
                                    <div data-src={data.product_image} className='border rounded px-1 py-0'>
                                        <img src={data.product_image} alt={data.product_name} className='cursor-pointer w-60px h-60px' />
                                    </div>
                                </LightGallery>
                                <div className='d-flex flex-column align-items-start'>
                                    <label className='text-black font-w600 fs-7'>{data.product_name}</label>
                                    <label className='text-dark font-w600 fs-7'>{data.product_category_name}</label>
                                </div>
                            </div>
                        </div>
         
                        <div className='col-lg-12 col-md-12 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-black text-start font-w600 fs-7'>Box Count</label>
                            <div className='d-block'>
                                <Badge bg="primary" className='text-white fs-6 px-3 py-0'>{data.subscriber_count}</Badge>
                            </div>
                        </div>
                        <div className='col-lg-12 col-md-12 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-black text-start font-w600 fs-7'>Total Items</label>
                            <div className='d-block'>
                                <Badge bg="primary" className='text-white fs-6 px-3 py-0'>{data.item_list.length}</Badge>
                            </div>
                        </div>
                        <div className='col-lg-12 col-md-12 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-black text-start font-w600 fs-7'>Packed Items</label>
                            <div className='d-block'>
                                <Badge bg="primary" className='text-white fs-6 px-3 py-0'>{data.packed_item_count ?? 0}</Badge>
                            </div>
                        </div>
                    </div>
                </div>
 
                <div className='col-lg-8 mb-2'>
                    <div className='row'>
                        <div className='col-lg-12 mb-2'>
                            <label className='text-red font-w600 fs-4 mb-2'>Items Packing</label> 
                        </div>
                        <div className='col-lg-12 mb-2 scroll-y' style={{maxHeight: '300px'}}> 
                            <div className='row mb-2'>
                                <div className="table-container mb-2">
                                    <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                        <thead>
                                            <tr className=" text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                <th className='min-w-10px'> 
                                                    Packed
                                                </th>
                                                <th className='min-w-100px'>Item</th>
                                                <th className='min-w-50px'>Cooked Qty</th>
                                                <th className='min-w-50px'>Per Box Qty</th>
                                                <th className='min-w-50px text-center'>Total Qty</th>
                                                {/* <th className='min-w-25px text-end'>Status</th> */}
                                            </tr>
                                        </thead>
                                        <tbody className="text-gray-600 fw-semibold fs-7">
                                            {data.item_list.map(item => (
                                            <tr key={item.id}>
                                                <td>
                                                    <div className="form-check custom-checkbox">
                                                        <input
                                                        type="checkbox"
                                                        className="form-check-input me-3"
                                                        id={`customCheckBox${item.id}`}
                                                        checked={item.status !== 0} // ✔ Checked if status is 1 or 2
                                                        disabled // ✔ Always read-only
                                                        />
                                                    </div>
                                                </td>
                                                <td>
                                                    <label className='text-black font-w400 fs-7'>{item.item_name}</label>
                                                </td>
                                                 <td>
                                                    <label className='text-black font-w400 fs-7'>
                                                        <span className='me-2'>{item.cooked_quantity}</span>
                                                        <span>{item.cooked_unit}</span>
                                                    </label>
                                                </td>
                                                <td>
                                                    <label className='text-black font-w400 fs-7'>
                                                        <span className='me-2'>{item.base_quantity}</span>
                                                        <span>{item.base_unit_name}</span>
                                                    </label>
                                                </td>
                                                <td className='text-center'>
                                                    <label className='text-black font-w400 fs-7'>
                                                        <span className='me-2'>{item.packing_quantity} </span>
                                                        <span>{item.packing_unit}</span>
                                                    </label>
                                                </td>
                                                {/* <td className='text-end text-black'>{item.item_list_status} </td> */}
                                            </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        {/* <div className='col-lg-12 mb-2'>
                            <label className='text-red font-w600 fs-4 mb-2'>Allotted Vehicles</label> 
                        </div>
                        <div className='col-lg-12 mb-2 scroll-y' style={{maxHeight: '400px'}}>
                            {assignments.map((assignment, idx) => (
                                <div className='row mb-4' key={idx}> 
                                    <div className="col-lg-4 mb-2 d-flex flex-column ">
                                        <label className="text-black font-w600 fs-6">Vehicle</label>
                                        <div className="d-flex flex-row align-items-start justify-content-start gap-2 mb-2">
                                            <label className="text-primary font-w500 fs-7">{assignment.vehicle.name}</label>
                                            <label className="text-dark font-w500 fs-7">({assignment.vehicle.number})</label>
                                        </div>
                                    </div>
 
                                    <div className="col-lg-4 mb-2 d-flex flex-column ">
                                        <label className="text-black font-w600 fs-6">Staff</label>
                                        <label className='text-primary font-w500 fs-7'>{assignment.staff}</label>
                                    </div>
                                    <div className='col-lg-12'>
                                        <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                            <thead>
                                                <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                    <th className="min-w-100px">Meals Point</th>
                                                    <th className="min-w-50px text-center">Product Count</th>
                                                </tr>
                                            </thead>
                                            <tbody className="text-gray-600 fw-semibold fs-7">
                                                {Object.entries(assignment.points).map(([point, value]) => (
                                                    <tr key={point}>
                                                        <td>
                                                            <label className="text-black font-w400 fs-7">{point}</label>
                                                        </td>
                                                        <td className="text-black fs-7 text-center">{value}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            ))}
                        </div> */}
                    </div>
                </div>

            </div>
        </>
    )
}

export default View_Sub;
